import type { Speed } from '../types'

const thresholds: { limit: number; speed: Speed }[] = [
  { limit: 500, speed: 'slow' },
  { limit: 20, speed: 'normal' }
]

export const getSpeedByAmount = (amount: number): Speed =>
  thresholds.find(({ limit }) => amount >= limit)?.speed || 'fast'
